'use strict'

/**
 * True only when the whole product is out of stock (every colour/size).
 * One out-of-stock size does not count — other sizes and colours are still
 * buyable, so the carousel should stay (AD-910).
 *
 * Checks colour groups first, then size variants. A simple product with no
 * options falls back to the variant-level flag. Anything not explicitly
 * out of stock is treated as in stock.
 *
 * @param {Object|null} product - product with `variationGroups` / `variants`
 * @param {boolean} [variantOutOfStock] - fallback flag for simple products
 * @returns {boolean}
 */
export const isProductFullyOutOfStock = (product, variantOutOfStock) => {
    const groups = product?.variationGroups
    if (Array.isArray(groups) && groups.length > 0) {
        return groups.every((group) => group?.orderable === false)
    }

    const variants = product?.variants
    if (Array.isArray(variants) && variants.length > 0) {
        return variants.every((variant) => variant?.orderable === false)
    }

    return variantOutOfStock === true
}
